module.exports = require("regenerator-runtime");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/regenerator/index.js
 ** module id = 515
 ** module chunks = 0
 **/